<script>

import {Link} from "svelte-routing";
import Button from "./Button.svelte";
import NavBar from "./NavBar.svelte";
</script>

<NavBar/>

<nav>
    <div class="links">
        <Link to="/portal">
            <Button text="Portal"/>
        </Link>
        <Link to="/users">
            <Button text="Users"/>
        </Link>
        <Link to="/game-rounds">
            <Button text="Game Rounds"/>
        </Link>
        <Link to="/dfg-prizes">
            <Button text="DFG Prizes"/>
        </Link>
        <Link to="/magic-wallet">
            <Button text="Magic Wallet"/>
        </Link>

    </div>
</nav>

<style>
    body {
        background: var(--background-color);
    }

    nav {
        background: var(--dark-background);
        margin: 0 auto;

        border-bottom: 2px solid #232323;
        border-left: 2px solid #232323;
        border-right: 2px solid #232323;

        width: fit-content;
    }

    .links {
        display: flex;
        justify-content: space-around;
        align-items: center;
        gap: 12px;
        padding: 12px;
        font-size: 0.8rem;
    }
</style>
